const inicialState = {
  alturaEditor: '',
  larguraEditor:'',
  editorCarregado: false,
  editorInicializado: false,
  textoInicial: false,
  autoSaveEditor: false,
  showEditor: false,
  textRtf: '',
  idRtf: 0,
  plainText: '',
  editorReadOnly: false,
  medExecutante: 0,
  medRevisor: 0,
  status: 'pendente',
  mensagem: '',
  tipo: 'sucesso',
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/componentes/editor/editor.state.js